import { graphql, useStaticQuery } from 'gatsby'
import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';

/** Used by CMS */
export const MixtapesPageTemplate = (props) => {
  const {
    src
  } = props;
  return (
    <div>

      <iframe width="100%" height="400"
              src={src}
              frameBorder="0"/>
    </div>
  )
}

MixtapesPageTemplate.propType = {
  id: PropTypes.string,
  src: PropTypes.string,
}

/** Used by UI at runtime */
export const RuntimeMixtape = (props) => {
  // console.time('all content query');
  const { mixtapes } = useStaticQuery(
    graphql`
          query AllMixtapes {
            mixtapes: allMarkdownRemark(filter: {frontmatter: {templateKey: {eq: "mixtape-page"}}}) {
              edges {
                  node {
                  fields {
                      slug
                  }
                  id
                  frontmatter {
                      src
                      }
                  }
              }
          }
      }
      `);
  // console.timeEnd('all content query');
  // needs a dummy product for the build to compile since no productId is available
  let mixtape = {
    frontmatter: {
      src: '',
    }
  };
  mixtapes.edges.forEach((edge) => {
    if (edge.node.id === props.mixtapeId) mixtape = edge.node;
  });
  return (
    <MixtapesPageTemplate
      {...mixtape.frontmatter}
    />
  )
}

export default RuntimeMixtape;
